import { forwardRef, memo } from 'react';
import { useControl } from '../use-control';
import { SwitchProps } from '../controls.types';
import { HiddenInput } from '../controls.styled';
import { StyledSwitch } from './switch.styled';

export const Switch = memo(
  forwardRef<HTMLInputElement, SwitchProps>((props, ref) => {
    const {
      checked: controlledChecked,
      onChange,
      onCheckedChange,
      disabled,
      size = 'm',
      style,
      ...restProps
    } = props;

    const { checked, handleChange } = useControl(
      controlledChecked,
      onChange,
      onCheckedChange
    );

    return (
      <StyledSwitch $size={size} style={style}>
        <HiddenInput
          {...restProps}
          type="checkbox"
          ref={ref}
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
        />
      </StyledSwitch>
    );
  })
);

Switch.displayName = 'Switch';
